import * as types from '../../constants/log/walletConnectionLogConstants';

export const walletConnectionLogListRequest = ({
  page,
  pageLength,
  beginDate,
  endDate,
  accountNo,
  walletAddress,
  callback,
  error,
}) => ({
  type: types.WALLET_CONNECTION_LIST_REQUEST,
  page,
  pageLength,
  beginDate,
  endDate,
  accountNo,
  walletAddress,
  callback,
  error,
})
